import * as React from 'react';
import * as ReactDOM from 'react-dom';

import { Routing } from 'modules';
import 'main/css/app.css';

ReactDOM.render(<Routing />, document.getElementById('root'));
